import { LangCode } from "../types/lang";
import { httpClient } from "./httpClient";
import { LANG } from "../configs/lang";

export async function getLanguageMessages(langCode: LangCode) {
    const response = await httpClient.get(LANG[langCode].link, { skipAuth: true, params: { timestamp: Date.now() } })
    return response.data || {}
}